// extracted by mini-css-extract-plugin
export default {"content":"Especialidade_content__bT1rO","optionsContainer":"Especialidade_optionsContainer__ctK6A"};